import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 9B0263DD-74DB-4AC6-BF1C-0C7C0170C845
 * name message-reply-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-reply-outline.svg
 * tags
 */
export const MessageReplyOutlineIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2M20 17.2L18.8 16H4V4H20V17.2Z" /></>, 'MessageReplyOutlineIcon');
export default MessageReplyOutlineIcon